// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export { CaseStatus, TERMINAL_STATUSES, SLA_PAUSED_STATUSES, SubStatus, SUB_STATUS_TO_STATUS, VALID_TRANSITIONS, } from './status.js';
export { RequestType, ALL_REQUEST_TYPES, REQUEST_TYPE_LABELS } from './request-types.js';
export { Permission, SystemRole, ROLE_PERMISSIONS } from './permissions.js';
export { AuditActionType, ActorType, SystemActorId, EventSensitivity, 
// Sprint 43.0.0 — audit payload enrichments
PauseReasonCode, RejectionReasonCodeEnum, } from './audit.js';
/** Supported locales. */
export const Locale = {
    VI: 'vi-VN',
    EN: 'en-US',
    DA: 'da-DK',
    SV: 'sv-SE',
    NB: 'nb-NO',
    NN: 'nn-NO',
    DE: 'de-DE',
    FI: 'fi-FI',
    NL: 'nl-NL',
    FR: 'fr-FR',
    LB: 'lb-LU',
    GA: 'ga-IE',
    ES: 'es-ES',
    CA: 'ca-ES',
    EU: 'eu-ES',
    PT: 'pt-PT',
};
/** Locale options for language selector dropdowns. */
export const LOCALE_OPTIONS = [
    { value: Locale.EN, label: 'English' },
    { value: Locale.VI, label: 'Tiếng Việt' },
    { value: Locale.DA, label: 'Dansk' },
    { value: Locale.SV, label: 'Svenska' },
    { value: Locale.NB, label: 'Norsk bokmål' },
    { value: Locale.NN, label: 'Norsk nynorsk' },
    { value: Locale.DE, label: 'Deutsch' },
    { value: Locale.FI, label: 'Suomi' },
    { value: Locale.NL, label: 'Nederlands' },
    { value: Locale.FR, label: 'Français' },
    { value: Locale.LB, label: 'Lëtzebuergesch' },
    { value: Locale.GA, label: 'Gaeilge' },
    { value: Locale.ES, label: 'Español' },
    { value: Locale.CA, label: 'Català' },
    { value: Locale.EU, label: 'Euskara' },
    { value: Locale.PT, label: 'Português' },
];
/** Case source (intake channel). */
export const CaseSource = {
    ADMIN_MANUAL: 'admin_manual',
    PUBLIC_FORM: 'public_form',
    CMP_GATEWAY: 'cmp_gateway',
    AESIRX_CMP: 'aesirx_cmp',
    PHONE_RECEIVED: 'phone_received',
    POSTAL_RECEIVED: 'postal_received',
    EMAIL_RECEIVED: 'email_received',
    IN_PERSON: 'in_person',
    LEGACY_IMPORT: 'legacy_import',
};
/** Closure reasons for terminal statuses. */
export const ClosureReason = {
    FULFILLED: 'fulfilled',
    PARTIALLY_FULFILLED: 'partially_fulfilled',
    UNFOUNDED: 'unfounded',
    EXCESSIVE: 'excessive',
    WITHDRAWN: 'withdrawn',
    DUPLICATE: 'duplicate',
    IDENTITY_UNVERIFIED: 'identity_unverified',
};
/** Identity verification statuses. */
export const VerificationStatus = {
    NOT_REQUIRED: 'not_required',
    PENDING: 'pending',
    VERIFIED: 'verified',
    FAILED: 'failed',
};
/** Note types. */
export const NoteType = {
    COMMENT: 'comment',
    STATUS_CHANGE: 'status_change',
    SLA_EVENT: 'sla_event',
    VERIFICATION_EVENT: 'verification_event',
    SYSTEM: 'system',
};
/** Note visibility. */
export const NoteVisibility = {
    INTERNAL: 'internal',
};
// Sprint 18.0.0: Package Deployment & License Management
export { PackageTier, PACKAGE_DEFINITIONS, getPackageModules, isModuleInPackage, 
// Sprint 45.3.0: Help Center package-tier awareness
HELP_MODULE_TO_MODULE_ID, ALWAYS_VISIBLE_HELP_MODULES, ENTERPRISE_ONLY_HELP_MODULES, isHelpModuleVisibleInTier, } from './packages.js';
// Sprint 37.1.0: Canonical Field Registry
export { CANONICAL_FIELDS, CANONICAL_REGISTRY_VERSION, } from './canonical-fields.js';
// Sprint 37.1.0: Workflow Profiles
export { WORKFLOW_PROFILES, getWorkflowProfile, getProfileStatuses, isValidProfileTransition, } from './workflow-profiles.js';
// Sprint 47.4.4: Immutable Audit Trails credit-package pricing card
export { IAT_CREDIT_PACKAGES, IAT_CREDIT_PACKAGE_CODES, } from './iat-pricing.js';
// Sprint 48.5.x: Forseti "Buy More" billing-unit bundle pricing card
export { FORSETI_BUNDLES, FORSETI_BUNDLE_CODES, } from './forseti-billing.js';
// F17 (fix-sprint-20260503-2128) — single source of truth for the
// canonical Mongo collection backing each ParentRecordType.
export { COLLECTION_BY_RECORD_TYPE } from './parent-record-collections.js';
// fix-sprint-20260619-0053-followup-2 (finding #9) — locale-keyed PDPL
// email + cover-letter template strings.
export { PDPL_EMAIL_BODY_GREETINGS, PDPL_EMAIL_BODY_COVER_LETTER_DIVIDER, PDPL_EMAIL_BODY_OPERATOR_NOTES_DIVIDER, PDPL_COVER_LETTER_LABELS, } from './pdpl-email-templates.js';
//# sourceMappingURL=index.js.map